//helpers
import { cutText } from "helpers/test"

const MiniHeading = ({ heading }) => {
    return (
        <div className="heading" dangerouslySetInnerHTML={{ __html: heading }} />
    )
}

export default MiniHeading